var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"self_sec"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"logout_window"},[_c('div',{staticClass:"card"},[_c('h4',[_vm._v(" You have been logged out. You can close this window. ")])])])])])
}]

export { render, staticRenderFns }